<template>
  <div class="right-menu-box-time">
    <div class="clock-wrapper">
      <div v-if="size == 'small'" class="clock--small">
        {{ realClock[0].current }}<span :class="{blink: realClock[2].current % 2}">:</span
        >{{ realClock[1].current }}
      </div>
      <div v-if="size == 'big'" class="clock--big">
        <div v-for="(time, id) in realClock" :key="`time_${id}`" class="clock-pair">
          <span class="digit digit-first" v-text="divider(time.current)[0]"></span>
          <span class="digit digit-second" v-text="divider(time.current)[1]"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Clock',
  props: {
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      curTime: new Date(0),
      realClock: [
        {max: 23, current: 0},
        {max: 59, current: 0},
        {max: 59, current: 0}
      ]
    }
  },
  computed: {
    computedRealClock() {
      const {realClock} = this
      return realClock.map(clock => ({
        ...clock,
        nextFormat: `0${clock.current + 1 > clock.max ? 0 : clock.current + 1}`,
        currentFormat: `0${clock.current}`,
        ifTens: parseInt(clock.current / 10) !== parseInt((clock.current + 1) / 10)
      }))
    }
  },
  methods: {
    /**
     * index: 0 - hour, 1 - minute, 2 - second
     */
    setTime(time, id) {
      let decimalTime = time < 10 ? '0' + time : time
      this.realClock[id].current = decimalTime
    },
    timeFlies() {
      const newTime = new Date()
      if (newTime.getHours() !== this.curTime.getHours()) {
        this.setTime(newTime.getHours(), 0)
      }
      if (newTime.getMinutes() !== this.curTime.getMinutes()) {
        this.setTime(newTime.getMinutes(), 1)
      }
      if (newTime.getSeconds() !== this.curTime.getSeconds()) {
        this.setTime(newTime.getSeconds(), 2)
      }
      this.curTime = newTime
      requestAnimationFrame(this.timeFlies)
    },
    divider(el) {
      return String(el).split('')
    }
  },
  created() {
    this.timeFlies()
  }
}
</script>

<style lang="scss" scoped>
.clock {
  padding: 10px;
  font-size: 1.5rem;
  color: #000000;
}

.clock--small {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  width: 80px;
  bottom: 100px;
  height: 70px;
  font-size: 1.5rem;
  color: #000000;
  background-color: #fad877;
  opacity: 1;

  .blink {
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
  }
}

.clock--big {
  display: flex;
  justify-content: flex-end;
  padding: 28px 21px 38px 0;
  font-size: 2.25rem;
  line-height: 1;
  color: #000000;
  background: #ffffff;
  box-shadow: -12px 0px 40px rgba(0, 0, 0, 0.05);
}

.clock-pair + .clock-pair {
  &:before {
    content: ':';
    padding: 0 10px 5px;
  }
}

.digit {
  background: #fad877;
  border-radius: 5px;
  padding: 8px 5px;

  + .digit {
    margin-left: 4px;
  }
}
</style>
